import { Search } from "lucide-react";
import { Button } from "@/components/ui/button";

export function SearchTrigger({ className, label = false, onOpen }: { className?: string; label?: boolean; onOpen?: () => void }) {
  return <Button variant="ghost" size={label ? "default" : "icon"} className={className} aria-label="Search website" title="Search website" onClick={() => { onOpen?.(); window.dispatchEvent(new Event("dex:open")); }}><Search className="h-5 w-5" />{label && "Search website"}</Button>;
}